export enum PaymentStatuses {
  HOLD_PERIOD = "HOLD_PERIOD",
  PENDING = "PENDING",
  AMP_INVOICE_REQUESTED = "AMP_INVOICE_REQUESTED",
  AMP_INVOICE_PAID = "AMP_INVOICE_PAID",
  PAYMENT_REQUEST_SENT = "PAYMENT_REQUEST_SENT",
  ARTIST_PAYMENT_REQUESTED = "ARTIST_PAYMENT_REQUESTED",
  ARTIST_PAID = "ARTIST_PAID",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  INVOICE_REQUEST_SENT = "INVOICE_REQUEST_SENT",
  CREDIT_NOTE_REQUESTED = "CREDIT_NOTE_REQUESTED",
  CREDIT_NOTE_ISSUED = "CREDIT_NOTE_ISSUED",
  RETURNED = "RETURNED",
  CLOSED = "CLOSED",
}

export enum PaymentLineStatuses {
  PROVISIONAL = "PROVISIONAL",
  READY_TO_REQUEST = "READY_TO_REQUEST",
  SENT_TO_FINANCE = "SENT_TO_FINANCE",
  READY_TO_PAY = "READY_TO_PAY",
  PAID = "PAID",
  BOUNCED_PAYMENT = "BOUNCED_PAYMENT",
  FAILED_TO_SEND = "FAILED_TO_SEND",
  CANCELLED = "CANCELLED",
  RETURNED = "RETURNED",
  CLOSED = "CLOSED",
}

export const ReciprocalCountries = [
  "Australia",
  "Austria",
  "Belgium",
  "Czech Republic",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Netherlands",
  "Norway",
  "Portugal",
  "Spain",
  "Sweden",
  "United Kingdom",
  "Estonia",
  "Greece",
  "Lithuania",
  "Mexico",
  "New Zealand",
  "Poland",
  "Romania",
  "Slovakia",
  "Uruguay",
  "Unknown",
];
//TODO add status reason enum for the "resale status reason" field. https://copyright.atlassian.net/browse/NRRS-356

export enum InvoiceStatuses {
  GENERATION_REQUESTED = "GENERATION_REQUESTED",
  GENERATION_CONFIRMED = "GENERATION_CONFIRMED",
  INVOICE_RECEIVED = "INVOICE_RECEIVED",
  GENERATION_COMPLETE = "GENERATION_COMPLETE",
  GENERATION_FAILED = "GENERATION_FAILED",
  MANUAL_REVIEW = "MANUAL_REVIEW",
}
